var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGorro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 160,
    viewBox: "0 0 247 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 1.36843C82.0584 9.09534 48.5082 48.909 36.8008 67.85C99.1429 81.3971 225.307 105.531 231.228 93.6899C237.148 81.8487 210.949 45.1877 197.109 28.3373C188.119 22.2746 167.105 8.84447 154.962 3.6263C142.82 -1.59187 128.328 -0.0531827 122.6 1.36843Z",
    fill: "#D31010"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.43,
    cy: 104.489,
    rx: 15.6796,
    ry: 14.1744,
    fill: "url(#paint0_radial_119_1578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.219 34.4265C167.886 33.0996 166.627 31.9383 165.5 30.9717C166.891 32.0148 168.126 33.174 169.219 34.4265C178.32 43.488 190.868 60.2711 188.33 75.5018C187.828 78.5122 185.419 83.9311 179.8 81.5227C174.18 79.1143 173.946 76.5053 174.531 75.5018C177.252 66.1682 179.481 46.1864 169.219 34.4265Z",
    fill: "url(#paint1_linear_119_1578)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.556 45.271C143.857 44.9319 142.289 44.6791 140.914 44.5063C142.552 44.6096 144.098 44.8724 145.556 45.271C157.16 47.5866 174.86 53.9273 178.676 66.3103C179.43 68.7579 179.464 73.8801 173.566 74.7882C167.667 75.6963 166.425 73.8935 166.542 72.8786C165.227 64.7354 159.252 49.0138 145.556 45.271Z",
    fill: "url(#paint2_linear_119_1578)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.033 50.0371C137.334 49.698 135.765 49.4453 134.391 49.2725C136.028 49.3757 137.574 49.6385 139.033 50.0371C150.636 52.3527 168.336 58.6934 172.152 71.0764C172.907 73.524 172.941 78.6462 167.042 79.5543C161.144 80.4624 159.902 78.6596 160.018 77.6447C158.704 69.5015 152.728 53.78 139.033 50.0371Z",
    fill: "url(#paint3_linear_119_1578)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5645 66.0942C44.5785 49.0347 58.3766 38.498 61.5124 38.498C57.4986 51.5435 80.9131 54.8885 92.9969 55.1811L91.6171 66.8468C71.9235 72.9096 36.5505 83.1536 40.5645 66.0942Z",
    fill: "url(#paint4_linear_119_1578)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3857 92.6573C8.07437 71.3464 24.0256 70.3981 32.4151 72.5878C36.9798 53.8425 50.9086 60.6567 57.3025 66.407C61.7457 52.7263 74.3902 55.6089 80.1571 58.7603C97.8393 44.2099 116.157 55.1309 123.106 62.4101C140.53 51.7078 152.947 60.2419 156.977 65.8468C166.137 63.4637 177.622 71.3837 182.22 75.6416C190.785 69.999 198.71 75.7416 201.603 79.3182C214.417 80.8061 213.753 82.5745 220.323 88.613C225.579 93.4438 219.953 102.822 216.484 106.907C219.043 112.215 220.35 125.477 205.096 136.058C189.843 146.64 162.771 129.002 151.142 118.86C128.224 136.955 98.6386 125.266 86.7108 117.159C65.5477 123.23 26.6365 130.603 13.8452 123.168C1.05388 115.734 4.67149 100.7 11.3857 92.6573Z",
    fill: "url(#paint5_radial_119_1578)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_119_1578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.43 104.489) rotate(92.9712) scale(36.3 40.1549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.230769,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_119_1578",
    x1: 170.47,
    y1: 30.8576,
    x2: 189.788,
    y2: 86.9279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_119_1578",
    x1: 146.512,
    y1: 34.37,
    x2: 183.641,
    y2: 84.4193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_119_1578",
    x1: 136.225,
    y1: 38.1326,
    x2: 175.111,
    y2: 94.4537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_119_1578",
    x1: 66.6553,
    y1: 47.4041,
    x2: 40.3136,
    y2: 67.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#510B0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_119_1578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.616 99.1238) rotate(89.9676) scale(53.1571 117.947)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.586538,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGorro);
export default __webpack_public_path__ + "static/media/gorro.555f4ce99483901c9b6d76db4c67d5ec.svg";
export { ForwardRef as ReactComponent };